package com.eladfinish.bible.contest.network.config

import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.network.logging.NetworkLogLevel

class NetworkConfiguration(
    private val debugInfo: DebugInfo,
) : NetworkClientConfiguration {
    override val baseUrl = ""
    override val logLevel = getNetworkLogLevel()

    private fun getNetworkLogLevel() =
        if (debugInfo.isDebugMode) {
            NetworkLogLevel.ALL
        } else {
            NetworkLogLevel.INFO
        }
}
